import * as React from "react";
import Spinner from "nx-components/Spinner";
import Theme from "nx-components/Theme";
import prefixStyles from "nx-components/utils/prefixStyles";

const styles = prefixStyles({
  container: {
    position: "absolute",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: Theme.zIndexLayers.MODAL + 1,
    cursor: "default",
    background: "rgba(255, 255, 255, .75)",
  },
});

export default class TileSpinner extends React.Component {
  render() {
    return (
      <div style={styles.container} data-component-name="TileSpinner">
        <Spinner />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tiles/TileSpinner.jsx